import { Record } from 'immutable';
import BestIncentivesModelV25 from 'commons-vehicle/PurchaseMethodsV25/models/BestIncentivesModelV25.js';
import ExteriorColourPhotoModelV25 from 'commons-vehicle/Vehicle/models/ExteriorColourPhotoModelV25.js';

const CashPurchaseRecord = Record({
    feesDisclaimer: '',
    incentives: new BestIncentivesModelV25(),
    isAllIncludedPrice: false,
    lien: 0, // 1500
    retailDetails: {
        msrp: 0, // 32877
        freightAndPDI: 0,
        taxesAndDuties: 0,
        otherFeesAndItems: 0,
        total: 0, // 32877
    },
    sellingPrice: 0,
    sellingPriceDisclaimer: '', // à l'achat au comptant
    taxesDisclaimer: '', // (GST / QST), licence & registration not included
    tradeIn: 0, // 2000
    tradeInTaxCreditsDetails: {
        tradeIn: 0, // 2500
        tradeInTaxCredits: 0, //  374.38
        taxesDetail: '', // GST/QST
        totalTradeIn: 0, // 2874.38
    },
    exteriorColourPhoto: new ExteriorColourPhotoModelV25(),
});

class CashPurchaseModelV25 extends CashPurchaseRecord {}

export default CashPurchaseModelV25;
